import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import onScan from 'onscan.js';
import { ButtonLoading } from 'src/app/models/button-loading.model';
import { PurchaseSeriesRequest, SeriesRequest, SeriesResponse } from 'src/app/models/purchase.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { ProductService } from 'src/app/services/product.service';

@Component({
  selector: 'app-modal-purchase-serie',
  templateUrl: './modal-purchase-serie.component.html',
  styleUrls: ['./modal-purchase-serie.component.scss']
})
export class ModalPurchaseSerieComponent implements OnInit, OnDestroy {
  @Output() close = new EventEmitter<any>();
  @Input() newListSeries = new PurchaseSeriesRequest();
  avoidDuplicates: { [key: string]: any } = {};
  deleting: { [key: string]: boolean } = {};
  tempSeriesName = "";
  buttonSave: ButtonLoading = new ButtonLoading("btn-success", false, "GUARDAR", "fa-save");

  constructor(
    private toastService: ToastrService,
    private productService: ProductService
  ) {

  }

  activateScanBarcode() {
    onScan.attachTo(document, {
      suffixKeyCodes: [13], // enter-key expected at the end of a scan
      reactToPaste: false, // Compatibility to built-in scanners in paste-mode (as opposed to keyboard-mode)
      onScan: (sCode, iQty) => {
        this.codeBar(sCode, iQty);
      }
    });
  }

  ngOnInit(): void {
    this.activateScanBarcode();
    this.addPreviousSeries()
  }

  addPreviousSeries() {
    this.newListSeries.dataSeries.forEach((series) => {
      this.avoidDuplicates[series.series] = series.series;
    });
  }

  ngOnDestroy(): void {
    onScan.detachFrom(document);
  }

  codeBar(sCode: string, iQty: string) {
    this.addSerie(sCode);
  }

  addTempSerie() {
    this.addSerie(this.tempSeriesName);
    this.tempSeriesName = "";
  }

  updateSeries() {
    this.newListSeries.dataSeries = [];
    this.avoidDuplicates = {};
    this.productService.getAssociateSeriesPurchase(this.newListSeries.productId, this.newListSeries.providerInvoice).subscribe({
      next: (response: ResponseObject) => {
        var actual_series = response.data as SeriesResponse[];
        actual_series.forEach((series) => {
          var seriesRequest = new SeriesRequest();
          seriesRequest.series = series.seriesProduct;
          seriesRequest.dataSeries = series;
          this.newListSeries.dataSeries.push(seriesRequest);
          this.avoidDuplicates[series.seriesProduct] = series.seriesProduct;
        })
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  addSerie(series) {
    if (this.avoidDuplicates[series]) {
      this.toastService.info("Se encuentra agregada la serie");
      return;
    }
    this.avoidDuplicates[series] = series;
    var temp = new SeriesRequest();
    temp.series = series;
    this.newListSeries.dataSeries.push(temp);
  }

  saveSeries() {
    if (this.buttonSave.loading) {
      return;
    }
    this.buttonSave.loading = true;
    var request = new PurchaseSeriesRequest();
    request.productId = this.newListSeries.productId;
    this.newListSeries.dataSeries.forEach((series) => {
      if (!series.dataSeries) {
        request.dataSeries.push(series);
      }
    })
    request.providerInvoice = this.newListSeries.providerInvoice;
    request.warehouseId = this.newListSeries.warehouseId;
    if (request.dataSeries.length > 0) {
      this.productService.addSerie(request).subscribe({
        next: (response: ResponseObject) => {
          this.toastService.success("Se han agregado correctamente las series");
          this.buttonSave.loading = false;
          this.updateSeries();
        },
        error: (error: HttpErrorResponse) => {
          this.buttonSave.loading = false;
          this.toastService.error(error.error.message);
        }
      })
    } else {
      this.buttonSave.loading = false;
      this.toastService.success("Todas las series se encuentra ya guardadas");
    }
  }

  removeSerie(index) {
    var temp = this.newListSeries.dataSeries[index];
    if (this.deleting[temp.series]) {
      return;
    }
    this.deleting[temp.series] = true;
    if (temp.dataSeries) {
      this.productService.deleteAssociateSeries(temp.dataSeries.id).subscribe({
        next: (response: ResponseObject) => {
          delete this.deleting[temp.series];
          this.deleteSerieFromArray(temp.series, index);
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error("Error al eliminar la serie");
        }
      })
    } else {
      delete this.deleting[temp.series];
      this.deleteSerieFromArray(temp.series, index);
    }
  }

  deleteSerieFromArray(series, index) {
    delete this.avoidDuplicates[series];
    this.newListSeries.dataSeries.splice(index, 1);
    this.toastService.success("Serie eliminada correctamente!");
  }
}
